import React from "react";
import styled from "styled-components";
import { Row, Col } from "react-bootstrap";

import { FORM_FIELD_KEYS } from "../../../../../constants/forms";
import { getFieldProps } from "../../../../../utils/form-fields";
import { hexToRGBA } from "../../../../../utils/theme";

import TextInput from "../../../controls/TextInput";
import Select from "../../../controls/Select";

const StyledContainer = styled.div`
  margin-bottom: 24px;
`;

const StyledRow = styled(Row)`
  margin-top: 1rem;
  margin-bottom: 2rem;
  margin-right: 0;
  margin-left: 0;
  padding: 16px;
  border: 2px solid #797c7f;
`;

function TrustInfoBlock({ values = {}, onChange, onMouseEnter, onMouseLeave }) {
  return (
    <StyledContainer>
      <div className="inputs-block-title">
        <span>Legal information</span>
      </div>
      <StyledRow>
        <Col xs={12} md={6}>
          <TextInput
            {...getFieldProps(FORM_FIELD_KEYS.legalName)}
            hint={(
              <>
                Special instructions for entering the legal name of your trust:
                <ol>
                  <li style={{ fontSize: "16px", fontFamily: "Source Sans Pro", fontWeight: "normal" }}>
                    Omit any names of trustees.
                  </li>
                  <li style={{ fontSize: "16px", fontFamily: "Source Sans Pro", fontWeight: "normal" }}>
                    Place the individual&apos;s name at the beginning of your trust name.
                  </li>
                  <li style={{ fontSize: "16px", fontFamily: "Source Sans Pro", fontWeight: "normal" }}>
                    Do not enter the words &apos;date&apos; or &apos;dated&apos;.
                  </li>
                  <li style={{ fontSize: "16px", fontFamily: "Source Sans Pro", fontWeight: "normal" }}>
                    Do not enter the alpha month, replace with corresponding numeric character.
                  </li>
                  <li style={{ fontSize: "16px", fontFamily: "Source Sans Pro", fontWeight: "normal" }}>
                    Omit the word &apos;The&apos; from the beginning of your trust name.
                  </li>
                </ol>
                The only punctuation and special characters allowed are hyphen (-) and ampersand (&).
                <br />
                <br />
              The legal name may not contain any of the following endings: Corp, LLC, PLLC, LC, Inc, PA.
              </>
            )}
            label="Legal Name of Trust"
            defaultInvalidMessage="Please provide a valid trust name"
            value={values[FORM_FIELD_KEYS.legalName]}
            onChange={onChange}
            onMouseEnter={onMouseEnter}
            onMouseLeave={onMouseLeave}
          />
        </Col>
        <Col xs={12} md={6}>
          <Select
            {...getFieldProps(FORM_FIELD_KEYS.trustType)}
            label={getFieldProps(FORM_FIELD_KEYS.trustType)?.placeholder?.replace("*", "")}
            value={values[FORM_FIELD_KEYS.trustType]}
            validated={values.validated}
            onChange={onChange}
            onMouseEnter={onMouseEnter}
            onMouseLeave={onMouseLeave}
            hideDivider
          />
        </Col>
      </StyledRow>
    </StyledContainer>
  );
}

export default TrustInfoBlock;
